import { decorate, observable, action, computed, toJS } from "mobx";
import moment from "moment";

import AbstractStore from "../AbstractStore";


class Store extends AbstractStore {
    checkboxOptions = {
        "A": 'Today',
        "B": 'Tomorrow',
        "C": 'Yesterday',
        "F": 'This Quarter',
        "E": 'This Year',
        "G": 'Date Between',
        "I": 'In the future',
        "J": 'In the past',
        "H": 'Last Month',
        "D": 'This Month',
        "K": 'Next Month',
    };
    checkboxOptionsGroups = [
        [
            { value: "A", name: 'Today', },
            { value: "B", name: 'Tomorrow', },
            { value: "C", name: 'Yesterday', },
            { value: "F", name: 'This Quarter', },
            { value: "E", name: 'This Year', },
            { value: "G", name: 'Date Between', },
        ],
        [
            { value: "I", name: 'In the future', },
            { value: "J", name: 'In the past', },
        ],
        [
            { value: "H", name: 'Last Month', },
            { value: "D", name: 'This Month', },
            { value: "K", name: 'Next Month', },
        ]
    ]
    yearNames = [
        { "name": "January", },
        { "name": "February", },
        { "name": "March", },
        { "name": "April", },
        { "name": "May", },
        { "name": "June", },
        { "name": "July", },
        { "name": "August", },
        { "name": "September", },
        { "name": "October", },
        { "name": "November", },
        { "name": "December", },

    ];
    selectedOptions = new Set()
    yearStartsFrom = "January"
    startDate = ""
    endDate = ""

    constructor(props) {
        super(props);
    }

    get searchQuery() {
        let searchQuery = '';
        let dateQuery = '';

        this.selectedOptions.forEach((record) => {
            let query = this.getDateSearchQuery(record);
            if (query !== '') {
                dateQuery += query + ' OR ';
            }
        });
        dateQuery = dateQuery.substring(0, dateQuery.length - 4);

        if (dateQuery != '')
            if (searchQuery != "")
                searchQuery = '(' + searchQuery + ')' + ' OR ' + '(' + dateQuery + ')';
            else
                searchQuery = dateQuery;

        return searchQuery ? `  ${searchQuery}  ` : "";
    }

    getDateSearchQuery(type) {
        const startDate = this.startDate;
        const endDate = this.endDate;
        const monthStartsFrom = this.yearStartsFrom;

        let columnName = '';
        if (this.columnId === "created") {
            columnName = "createdOn";
        } else if (this.columnId === "updated") {
            columnName = "updatedOn";
        } else {
            columnName = this.columnAliasPath;
        }

        switch (type) {
            case "A": {
                let date = new Date(), month = date.getMonth() + 1, query = '';
                // query = 'DATE(' + columnName + ') = ' + "'" + date.getFullYear() + '-' + month + '-' + date.getDate() + "'";
                query = 'DATE(' + columnName + ') = CURDATE()';
                return query;
            }
            case "B": {
                let date = new Date(new Date().getTime() + 24 * 60 * 60 * 1000), month = date.getMonth() + 1, query = '';
                // query = 'DATE(' + columnName + ') = ' + "'" + date.getFullYear() + '-' + month + '-' + date.getDate() + "'";
                query = 'DATE(' + columnName + ') = DATE_ADD(CURDATE(), INTERVAL 1 DAY)';
                return query;
            }
            case "C": {
                let date = new Date(new Date().getTime() - 24 * 60 * 60 * 1000), month = date.getMonth() + 1, query = '';
                // query = 'DATE(' + columnName + ') = ' + "'" + date.getFullYear() + '-' + month + '-' + date.getDate() + "'";
                query = 'DATE(' + columnName + ') = DATE_SUB(CURDATE() , INTERVAL 1 DAY)';
                return query;
            }
            case "D": {
                let currentDate = new Date(), query = '';
                let month = currentDate.getMonth() + 1;
                let year = currentDate.getFullYear();
                // let queryYear = 'YEAR(' + columnName + ')' + ' = ' + "'" + year + "'";
                let queryYear = 'YEAR(' + columnName + ')' + ' = YEAR(CURDATE())';
                let queryMonth = 'MONTH(' + columnName + ')' + ' = MONTH(CURDATE())';
                // let queryMonth = 'MONTH(' + columnName + ')' + ' = ' + "'" + month + "'";
                query = "(" + queryMonth + ' AND ' + queryYear + ")";
                return query;
            }
            case "E": {
                let currentDate = new Date(), query = '';
                let month = new Date(Date.parse(monthStartsFrom + " 1, 2019")).getMonth() + 1

                // query = 'YEAR(' + columnName + ')' + ' = ' + "'" + year + "'";
                if (month == 1) {
                    query = 'YEAR(' + columnName + ')' + ' = YEAR(CURDATE())';
                } else {
                    query = 'DATE(' + columnName + ') BETWEEN ' + "" + "CONCAT( YEAR( CURDATE() ), '" + '-' + month + '-' + '1' + "')" + ' AND ' + 'LAST_DAY( CONCAT((YEAR(CURDATE()) + 1),\'' + '-' + (month - 1) + '-' + 1 + "' ) )";
                }
                return query;
            }
            case 'F': {
                let queryQuarter = 'QUARTER(' + columnName + ')' + ' = QUARTER(CURDATE())';
                let queryYear = 'YEAR(' + columnName + ')' + ' = YEAR(CURDATE())';
                return "("+ queryQuarter + ' AND ' + queryYear + ")";
            }
            case 'G': {
                if (startDate || endDate) {
                    let startDateQuery, endDateQuery, query;
                    let month, endMonth;
                    if (startDate) {
                        month = startDate.getMonth() + 1;
                        startDateQuery = 'DATE(' + columnName + ') >= ' + "'" + startDate.getFullYear() + '-' + month + '-' + startDate.getDate()+"'"
                    }
                    if (endDate) {
                        endMonth = endDate.getMonth() + 1;
                        endDateQuery = 'DATE(' + columnName + ') <= ' + "'" + endDate.getFullYear() + '-' + endMonth + '-' + endDate.getDate()+"'"
                    }
                    if (startDateQuery && endDateQuery) {
                        query = "("+startDateQuery + ' AND ' + endDateQuery + " AND DATE("+columnName+") > '0000-00-00')";
                    } else if (startDateQuery) {
                        query = startDateQuery
                    } else if (endDateQuery) {
                        query = endDateQuery
                    }
                    return query;
                }
                return '';
            }
            case 'H': {
                let currentDate = new Date(), query = '';
                // let queryYear = 'YEAR(' + columnName + ')' + ' = ' + "'" + year + "'";
                let queryYear = 'YEAR(' + columnName + ')' + ' = YEAR(CURDATE() - INTERVAL 1 MONTH)';
                let queryMonth = 'MONTH(' + columnName + ')' + ' = MONTH(CURDATE() - INTERVAL 1 MONTH)';
                // let queryMonth = 'MONTH(' + columnName + ')' + ' = ' + "'" + month + "'";
                query = queryYear + ' AND ' + queryMonth;
                return query;
            }
            case 'I': {
                return `( ${columnName} > NOW() )`
            }
            case 'J': {
                return `( ${columnName} < NOW() AND DATE(${columnName}) > '0000-00-00'  )`
            }
            case 'K': {
                let currentDate = new Date(), query = '';
                // let queryYear = 'YEAR(' + columnName + ')' + ' = ' + "'" + year + "'";
                let queryYear = 'YEAR(' + columnName + ')' + ' = YEAR(CURDATE() + INTERVAL 1 MONTH)';
                let queryMonth = 'MONTH(' + columnName + ')' + ' = MONTH(CURDATE() + INTERVAL 1 MONTH)';
                // let queryMonth = 'MONTH(' + columnName + ')' + ' = ' + "'" + month + "'";
                query = queryYear + ' AND ' + queryMonth;
                return query;
            }
            default:
                return '';
        }
    }

    doesFilterPass({ data, node }) {
        const columnValue = data[this.agGridProps.column.colDef.field];
        const monthStartsFrom = this.yearStartsFrom;

        return [...this.selectedOptions].findIndex(selectedOption => {
            switch (selectedOption) {
                case 'A':
                    const columnDate = columnValue !== '' ? new Date(columnValue) : null;
                        return moment(columnDate).startOf('day').diff(moment().startOf('day'), 'days') === 0;

                case 'B':
                    // return 'Tomorrow';
                    return moment(columnValue).startOf('day').diff(moment().startOf('day'), 'days') === 1;

                case 'C':
                    // return 'Yesterday';
                    return moment(columnValue).startOf('day').diff(moment().startOf('day'), 'days') === -1;
                case 'D':
                    // return 'This Month';
                    return new Date(columnValue).getMonth() === new Date().getMonth() && new Date(columnValue).getFullYear() === new Date().getFullYear()

                case 'F':
                    // return 'This Quarter';;
                    return new Date(columnValue).getFullYear() === new Date().getFullYear() && this.getDateQuarter(new Date(columnValue)) === this.getDateQuarter(new Date());
                case 'E': {
                    // return 'This Year';
                    let month = new Date(Date.parse(monthStartsFrom + " 1, 2019")).getMonth() + 1
                    const columnValueDateObj = new Date(columnValue);
                    const currentDate = new Date();

                    if (month === 1) {
                        return new Date(columnValue).getFullYear() === new Date().getFullYear()
                    }

                    let endDate = new Date((currentDate.getFullYear() + 1) + `-${month}-1`);
                    endDate.setDate(0);

                    return columnValueDateObj >= new Date(currentDate.getFullYear() + `-${month}-1`) && columnValueDateObj <= endDate;
                }
                case 'G': {
                    // return 'Date Between';
                    const startDate = new Date(this.startDate);//todo: add date
                    const endDate = new Date(this.endDate);
                    const columnValueDateObj = new Date(columnValue);

                    if (this.startDate && this.endDate) {
                        return columnValueDateObj >= startDate && columnValueDateObj <= endDate;
                    }

                    if (this.startDate) {
                        return columnValueDateObj >= startDate;
                    }

                    if (this.endDate) {
                        return columnValueDateObj <= endDate;
                    }

                    return true;
                }
                case 'H': {
                    // return 'Last Month';
                    let lastMonthDate = new Date();
                    lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);

                    return new Date(columnValue).getMonth() === lastMonthDate.getMonth() && new Date(columnValue).getFullYear() === lastMonthDate.getFullYear()
                }
                case 'I':
                    // in future
                    return new Date(columnValue) > new Date();
                case 'J':
                    // in past
                    return new Date(columnValue) < new Date();
                case 'K': {
                    //next month
                    let nextMonthDate = new Date();
                    nextMonthDate.setMonth(nextMonthDate.getMonth() + 1);

                    return new Date(columnValue).getMonth() === nextMonthDate.getMonth() && new Date(columnValue).getFullYear() === nextMonthDate.getFullYear()
                }
                default:
                    return false;
            }
        }) !== -1;
    }

    getDateQuarter = date => date.getMonth() + 1 % 4

    setModel = model => {
        if (!model) {
            this.selectedOptions.clear();
            this.startDate = null;
            this.endDate = null;
            return;
        }
        if (model.selectedOptions) {
            this.selectedOptions = new Set(model.selectedOptions);
        } else {
            this.selectedOptions.clear();
        }

        this.startDate = model.startDate ?? null;
        this.endDate = model.endDate ?? null;
    }
}

decorate(Store, {
    selectedOptions: observable,
    yearStartsFrom: observable,
    startDate: observable,
    endDate: observable,

    searchQuery: computed,
});

export default Store;
